import { webApiGet, webApiPost } from './core';

export function fetchWebApi(url, token = '', tokentype = '', addExtraToken = false) {
    return webApiGet(url, token, tokentype, addExtraToken);
}

export function postWebApi(url, bodyObject = {}, addExtraToken = false) {
    return webApiPost(url, bodyObject, addExtraToken);
}
